import { HttpStatus } from '@diritto/common/utils/requester/httpStatus';
import { AxiosError } from 'axios';
import { ModalParams, ModalType } from 'constants/modal';
import { ModalHandler } from 'utils/ModalHandler';

export const showErrorModal = (text: string, status: HttpStatus) => (error: AxiosError) => {
  if (error?.response?.status === status) {
    ModalHandler.show(ModalType.Alert, {
      title: text,
    });
  }
};

export const showAlertModal = (
  text: string | { title: string; description: string },
  params?: Omit<ModalParams[ModalType.Alert], 'title' | 'description'>,
) => {
  const modalText = typeof text === 'string' ? { title: text } : text;

  ModalHandler.show(ModalType.Alert, {
    ...modalText,
    confirmText: params?.confirmText,
    onConfirm: params?.onConfirm,
    cancelText: params?.cancelText,
    onCancel: params?.onCancel,
  });
};

export const showToast = (description: string, options?: ModalParams[ModalType.Toast]) => {
  ModalHandler.show(ModalType.Toast, {
    description,
    ...(options ?? {}),
  });
};
